export default {
  defaultProps: {
    disableRestoreFocus: true,
  },
};
